// Los argumentos de public.nexo_viz_hallazgos, nexo_viz_hallazgo_detalle y nexo_viz_evidencia, con las llaves exactas que valida la
// base (nexo.hallazgos_sujeto y nexo.evidencia, migración 20261003160000). Sin React ni import.meta.env, para probarlo con Deno contra las
// expresiones regulares de la propia migración (app/scripts/nexo-ficha.test.ts).

/**
 * El sujeto de la ficha: una entidad de la lista, una persona o empresa del registro en su corrida o, desde el corte 4a de los
 * certificados del SAT, un representante sin ficha confirmada por su uuid (nexo.hallazgos_sujeto, migración 20261017230000).
 */
export type SujetoFicha = { kind: "entity"; id: string } | { kind: "siger_actor"; id: string; runId: string } | { kind: "sat_rep"; id: string };

/** La llave de nexo.evidencia: un acto de la corrida vigente o un párrafo de una versión de un documento. */
export type LlaveEvidencia = { runId: string; actoId: number } | { versionId: number; fragmentId: string };

/** El argumento `p` de las tres funciones. */
export function argumentoSujeto(s: SujetoFicha): Record<string, string> {
  return s.kind === "siger_actor" ? { kind: "siger_actor", id: s.id, runId: s.runId } : { kind: s.kind, id: s.id };
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Los argumentos del detalle de una contraparte. La ficha conoce la contraparte por su referencia del documento (`entity:<uuid>`); la
 * base pide el uuid. null si la referencia no es de una entidad (no hay detalle que pedir).
 */
export function argumentosDetalle(s: SujetoFicha, contraparte: string): { p: Record<string, string>; p_contraparte: string } | null {
  const m = /^entity:(.+)$/.exec(contraparte);
  const uuid = m?.[1];
  if (!uuid || !UUID.test(uuid)) return null;
  return { p: argumentoSujeto(s), p_contraparte: uuid };
}

/** El argumento `p` de nexo.evidencia, con sólo las dos llaves de cada forma. */
export function argumentoEvidencia(llave: LlaveEvidencia): Record<string, string | number> {
  return "actoId" in llave ? { runId: llave.runId, actoId: llave.actoId } : { versionId: llave.versionId, fragmentId: llave.fragmentId };
}
